"use client";

import { useToastNotification } from "@/hooks/notifications/use-toast-noficication";
import { useEffect } from "react";
import { toast } from "sonner";

export function ToastProvider() {
    useToastNotification();
    useErrorNotificationFromUrlHash();

    return <></>;
}

function useErrorNotificationFromUrlHash() {
    useEffect(() => {
        const { hash } = window.location;

        // Check if the URL contains any error format with error= parameter
        if (hash.includes("error=")) {
            const urlParams = new URLSearchParams(hash.substring(1));
            const errorMessage = urlParams.get("error") ?? "An unknown error occurred";
            const errorType = urlParams.get("type") ?? "Error";

            console.error(`${errorType} Error:`, errorMessage);
            // Display the notification using Sonner after a second
            setTimeout(() => {
                toast.error(`${errorType} Error`, { description: decodeURIComponent(errorMessage) });
            }, 1000);
        }
    }, []);
}
